/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const RssIcon = ({ width = 24, height = 24, hidden = false, title = 'Rss' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <circle cx="7.993" cy="28.007" r="4" />
    <path
      d="M21.983 32.007h-4a.5.5 0 0 1-.5-.489 13.519 13.519 0 0 0-13-13 .5.5 0 0 1-.488-.5v-4a.5.5 0 0 1 .511-.5A18.525 18.525 0 0 1 22.486 31.5a.5.5 0 0 1-.503.507Z"
    />
    <path
      d="M31.985 32.007h-4a.5.5 0 0 1-.5-.493 23.7 23.7 0 0 0-23-23.19.5.5 0 0 1-.493-.5V4.015a.5.5 0 0 1 .51-.5A28.535 28.535 0 0 1 32.489 31.5a.5.5 0 0 1-.504.507Z"
    />
  </svg>`;
};
